const invoiceModalsCache = new Map(); // Cache to store modals by invoice number

async function getInvoiceHtml(invoiceNumber) {
  try {
    const response = await $.ajax({
      type: 'get',
      url: `/customer/invoices/${invoiceNumber}`,
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    });

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = response;
    tempDiv?.querySelector('.myinvoiceview').classList.remove('container');

    const invoiceHtml = tempDiv.querySelector('#invoiceView').outerHTML;
    return invoiceHtml;
  } catch (error) {
    console.error('Error fetching invoice HTML:', error);
    return '<p>Error loading invoice.</p>';
  }
}

async function createInvoiceModal(invoiceNumber) {
  // Check if the modal for this invoice already exists in the cache
  if (invoiceModalsCache.has(invoiceNumber)) {
    const cachedModal = invoiceModalsCache.get(invoiceNumber);
    $(cachedModal).modal('show'); // Show the cached modal
    return;
  }

  // Create the modal with a loader
  const invoiceModal = document.createElement('div');
  invoiceModal.classList.add('modal', 'fade');
  invoiceModal.id = `invoiceModal-${invoiceNumber}`;
  invoiceModal.classList.add('invoice-modal');
  invoiceModal.tabIndex = -1;
  invoiceModal.setAttribute('role', 'dialog');
  invoiceModal.setAttribute('aria-hidden', 'true');

  invoiceModal.innerHTML = `
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
        </div>
        <div class="modal-body">
          <div class="invoice-modal__loader">
          </div>
          <p>Loading invoice data...</p>
        </div>
      </div>
    </div>`;
  document.body.appendChild(invoiceModal);

  // Show the modal with the loader
  const invoiceModalElement = $(`#invoiceModal-${invoiceNumber}`);
  invoiceModalElement.modal('show');

  // Fetch the invoice HTML
  const invoiceHtml = await getInvoiceHtml(invoiceNumber);

  // Replace the loader with the actual content
  const modalBody = invoiceModal.querySelector('.modal-body');
  modalBody.innerHTML = invoiceHtml;

  // Cache the modal for future use
  invoiceModalsCache.set(invoiceNumber, invoiceModal);
}

(() => {
  const invoices = document.querySelectorAll('.invoiceNumber span a');
  if (!invoices.length) return;

  invoices.forEach((invoice) => {
    const invoiceNumber = invoice.innerText;
    invoice.addEventListener('click', async (e) => {
      e.preventDefault();
      await createInvoiceModal(invoiceNumber);
    });
  });
})();
